import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/machine/filter'; // Importing Filter component
import Table from 'views/machine/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * MachineRegisterView class extends JetView to create a machine registration view.
 */
export default class MachineRegisterView extends JetView {
    /**
     * Configures the UI components of the MachineRegisterView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            // Configuration for the right section
            type: 'wide',
            minWidth: 200,
            rows: [],
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Máquinas'),
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Máquinas'),
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            // Configuration for the left section
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Máquinas') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon to navigate back
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar, // Including toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer between sections
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
